<template>
  <div>
    <div class="header_box" align="center">
      <div class="divcss5 body-width">
        <a class="logo_box" @click="setroters('/index')">
          <img src="../../assets/images/logo.png" />
        </a>
        <ul class="nav_box">
          <li class="nav_1" @mouseleave="handleMouseLeave('index')">
            <a @click="setroters('/index')">
              <div :class="getHeaderTitle.showindex?'nav_but':'nav_but1'">{{$t('index.home')}}</div>
            </a>
          </li>
          <li class="nav_1">
            <a @click="setroters('/about')">
              <div :class="getHeaderTitle.showabout?'nav_but':'nav_but1'">{{$t('about.aboutus')}}</div>
            </a>
          </li>
          <li
            class="nav_1"
            @mouseenter="handleMouseEnter('product')"
            @mouseleave="handleMouseLeave('product')"
          >
            <a @click="setroters('/product')">
              <div
                :class="getHeaderTitle.showproduct?'nav_but':'nav_but1'"
              >{{$t('product.productcenter')}}</div>
            </a>
            <div class="nav_slide" id="nav_slide_product" style="height: 158px;width: 224px">
              <div class="nav_slide1">
                <!-- <a @click="setroters('/lmmad')">{{$t('product.product7')}}</a>
                <a @click="setroters('/webproductlist')">{{$t('product.product6')}}</a> -->
                
                <!-- <a @click="setroters('/productzncy/zncajkzzx')">{{$t('product.product2')}}</a> -->
                <!-- <a @click="setroters('/producthsyl/VTSzhylxt')">{{$t('product.product3')}}</a>
                <a @click="setroters('/productvr')">{{$t('product.product4')}}</a>
                <a @click="setroters('/producthlwhhjy')">{{$t('product.product5')}}</a> -->
                <a @click="setroters('/producthhmnq/productcp')">{{$t('product.product1')}}</a>
                <a @click="setroters('/producthhxnsx/hhxnxl')">{{$t('product.product8')}}</a>
                <a @click="setroters('/productznhy/zncbajyckzz')">{{$t('product.product9')}}</a>
                <a @click="setroters('/producthhwhyx/hhwhyxgkj')">{{$t('product.product10')}}</a>

                
              </div>
            </div>
          </li>
          <li class="nav_1" @click="setroters('/news')">
            <a>
              <div
                :class="getHeaderTitle.shownews?'nav_but':'nav_but1'"
              >{{$t('news.newsinfomation')}}</div>
            </a>
          </li>
          <li
            class="nav_1"
            @mouseenter="handleMouseEnter('join')"
            @mouseleave="handleMouseLeave('join')"
          >
            <a @click="setroters('/join/index')">
              <div :class="getHeaderTitle.showjoin?'nav_but':'nav_but1'">{{$t('join.joinus')}}</div>
            </a>
            <div class="nav_slide" id="nav_slide_join" style="height: 112px;width: 150px">
              <div class="nav_slide1">
                <a @click="setroters('/join/intern')">{{$t('join.intern')}}</a>
                <a @click="setroters('/join/programmer')">{{$t('join.programmer')}}</a>
                <a @click="setroters('/join/modeler')">{{$t('join.modeler')}}</a>
                <a @click="setroters('/join/engineer')">{{$t('join.engineer')}}</a>
              </div>
            </div>
          </li>
          <li class="nav_1">
            <a @click="setroters('/cooperation')">
              <div
                :class="getHeaderTitle.showpartner?'nav_but':'nav_but1'"
              >{{$t('cooperation.partner')}}</div>
            </a>
          </li>
          <li class="nav_1">
            <a @click="setroters('/contact')">
              <div
                :class="getHeaderTitle.showcontact?'nav_but':'nav_but1'"
              >{{$t('contact.contactus')}}</div>
            </a>
          </li>
          <li
            hidden
            class="nav_1"
            @mouseenter="handleMouseEnter('lan')"
            @mouseleave="handleMouseLeave('lan')"
          >
            <a class="nav_but" @click="switchStyle('/language')">
              <div>{{$t('language.chinese')}}</div>
            </a>
            <div class="nav_slide" id="nav_slide_lan" style="width: 125px;height: 68px">
              <div class="nav_slide1">
                <a @click="handleSwitchLanguage('zh')">简体中文</a>
                <a @click="handleSwitchLanguage('en')">English</a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "header-page",
  data() {
    return {
      url: "",
      header: {}
    };
  },
  methods: {
    ...mapMutations(["setHeaderTitle"]),
    setroters(src) {
      if (this.$route.path !== src) {
        this.switchStyle(src);
        this.$router.push(src);
      }
    },
    
    handleMouseEnter(val) {
      $("#nav_slide_" + val).slideDown();
    },
    handleMouseLeave(val) {
      $("#nav_slide_" + val).slideUp();
    },
    handleSwitchLanguage(lan) {
      this.$i18n.locale = lan;
    },
    switchStyle(src) {
      if ("/index" === src) {
        this.header.showindex = true;
        this.header.showabout = false;
        this.header.showproduct = false;
        this.header.shownews = false;
        this.header.showjoin = false;
        this.header.showcontact = false;
        this.header.showpartner = false;
        this.header.showlanguage = false;
      }
      if ("/about" === src) {
        this.header.showindex = false;
        this.header.showabout = true;
        this.header.showproduct = false;
        this.header.shownews = false;
        this.header.showjoin = false;
        this.header.showcontact = false;
        this.header.showpartner = false;
        this.header.showlanguage = false;
      }
      if (
        "/product" === src ||
        "/producthhmnq/productcp" === src ||
        "/productvr" === src ||
        "/productzncy/zncajkzzx" === src ||
        "/producthsyl/VTSzhylxt" === src ||
        "/producthlwhhjy" === src ||
        "/webproductlist" === src || "/lmmad" === src  
      ) {
        this.header.showindex = false;
        this.header.showabout = false;
        this.header.showproduct = true;
        this.header.shownews = false;
        this.header.showjoin = false;
        this.header.showcontact = false;
        this.header.showpartner = false;
        this.header.showlanguage = false;
      }
      if ("/news" === src) {
        this.header.showindex = false;
        this.header.showabout = false;
        this.header.showproduct = false;
        this.header.shownews = true;
        this.header.showjoin = false;
        this.header.showcontact = false;
        this.header.showpartner = false;
        this.header.showlanguage = false;
      }
      if (
        "/join/index" === src ||
        "/join/intern" === src ||
        "/join/programmer" === src ||
        "/join/modeler" === src ||
        "/join/engineer" === src
      ) {
        this.header.showindex = false;
        this.header.showabout = false;
        this.header.showproduct = false;
        this.header.shownews = false;
        this.header.showjoin = true;
        this.header.showcontact = false;
        this.header.showpartner = false;
        this.header.showlanguage = false;
      }
      if ("/cooperation" === src) {
        this.header.showindex = false;
        this.header.showabout = false;
        this.header.showproduct = false;
        this.header.shownews = false;
        this.header.showjoin = false;
        this.header.showcontact = false;
        this.header.showpartner = true;
        this.header.showlanguage = false;
      }
      if ("/contact" === src) {
        this.header.showindex = false;
        this.header.showabout = false;
        this.header.showproduct = false;
        this.header.shownews = false;
        this.header.showjoin = false;
        this.header.showcontact = true;
        this.header.showpartner = false;
        this.header.showlanguage = false;
      }
      if ("/language" === src) {
        this.header.showindex = false;
        this.header.showabout = false;
        this.header.showproduct = false;
        this.header.shownews = false;
        this.header.showjoin = false;
        this.header.showcontact = false;
        this.header.showpartner = false;
        this.header.showlanguage = true;
      }
      this.setHeaderTitle(this.header);
    }
  },
  computed: {
    ...mapGetters(["getHeaderTitle"])
  },
  mounted() {
    this.header = this.getHeaderTitle;
    if(localStorage.getItem('header')){
      this.setHeaderTitle(JSON.parse(localStorage.getItem('header')));
      console.log(this.header)
    }
  }
};
</script>

<style scoped>
.header_box {
  padding-left: 135px;
  height: 88px;
  background: #fffff9;
  position: fixed;
  width: 1920px;
  margin: 0 auto;
  z-index: 600;
  opacity: 0.8;
  text-align: center;
}

.logo_box {
  display: block;
  margin-top: 15px;
  text-align: left;
  position: relative;
  right: 90px;
}

.nav_box {
  height: 88px;
  margin-top: -50px;
  /*margin-left: 67px;*/
  margin-left: 120px;
}

.nav_box .nav_1 {
  float: left;
  position: relative;
  list-style: none;
}

.nav_but {
  font-size: 18px;
  color: white !important;
  padding: 35px 20px 30px 22px;
  font-weight: 700;
  background: #2e79be;
  width: 130px;
  position: relative;
  bottom: 34px;
  height: 88px;
}

.nav_but1 {
  font-size: 18px;
  color: #0d3e88 !important;
  padding: 35px 20px 30px 22px;
  font-weight: 700;
  width: 130px;
  height: 88px;
  position: relative;
  bottom: 34px;
}

.nav_but1:hover {
  cursor: pointer;
  background: #2e79be;
  color: white !important;
}

.nav_but:hover {
  cursor: pointer;
  background: #2e79be;
  color: white !important;
}

.nav_slide {
  position: absolute;
  left: 5px;
  display: none;
  top: 53px;
  z-index: 800;
}

.nav_slide1 {
  background: white;
  border-bottom: 3px solid #e0e2e3;
}

.nav_slide a {
  padding: 5px;
  text-align: left;
  margin-left: 0;
  width: 100%;
  color: #0d3e88;
  display: block;
  position: relative;
  border-bottom: 1px solid #eeeeee;
}

.nav_slide a:hover {
  background: #2e79be;
  color: white !important;
  text-decoration: none;
}

ul li {
  width: 140px;
}
</style>



// WEBPACK FOOTER //
// src/components/commoncoms/header.vue